// START A/B TEST CBSCOMSUB-8936: Consolidated Content Bucket
// Implements an event bus to communicate between modules
export const eventBus = {
    events: {},

    on(event, callback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
    },

    emit(event, data) {
        if (this.events[event]) {
            this.events[event].forEach((callback) => callback(data));
        }
    },
};
// END A/B TEST CBSCOMSUB-8936: Consolidated Content Bucket
